var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusAwaitingRetry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9 11L4.72711 7.43926C4.09226 6.91022 3.77484 6.6457 3.54664 6.32144C3.34444 6.03413 3.19429 5.71354 3.10301 5.37428C3 4.99139 3 4.57819 3 3.7518V1M9 11L13.2729 7.43926C13.9077 6.91022 14.2252 6.6457 14.4534 6.32144C14.6556 6.03413 14.8057 5.71354 14.897 5.37428C15 4.99139 15 4.57819 15 3.7518V1M9 11L4.72711 14.5607C4.09226 15.0898 3.77484 15.3543 3.54664 15.6786C3.34444 15.9659 3.19429 16.2865 3.10301 16.6257C3 17.0086 3 17.4218 3 18.2482V21M9 11L13.2729 14.5607C13.9077 15.0898 14.2252 15.3543 14.4534 15.6786C14.6556 15.9659 14.8057 16.2865 14.897 16.6257C15 17.0086 15 17.4218 15 18.2482V21M1 1H17M1 21H17",
    stroke: "var(--stroke-0, #FFAA76)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAwaitingRetry);
export default __webpack_public_path__ + "static/media/status-awaiting-retry.a6bea2d27c29691319f2601a70024bf0.svg";
export { ForwardRef as ReactComponent };